import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useUserDropdown = (onLogoutClick) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState('top');
  const triggerRef = useRef(null);
  const navigate = useNavigate();

  // Picks whichever side actually has room, instead of a fixed offset that
  // can overlap the trigger when the footer sits near the viewport edge.
  const resolveDropdownPosition = () => {
    if (!triggerRef.current) return 'top';
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;
    return spaceAbove >= spaceBelow ? 'top' : 'bottom';
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => {
      const next = !prev;
      if (next) setDropdownPosition(resolveDropdownPosition());
      return next;
    });
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const dropdownList = [
    {
      path: "/profile",
      onClickHandler: () => navigate("/profile"),
      variant: "profile",
      text: "Settings",
    },
    {
      onClickHandler: onLogoutClick,
      variant: "logout",
      text: "Logout",
    },
  ];

  const shouldShowDropdown = isDropdownOpen;

  return {
    triggerRef,
    toggleDropdown,
    closeDropdown,
    dropdownList,
    dropdownPosition,
    shouldShowDropdown,
  };
};
